import { PaidServiceName } from "../../../../domains/PaidService";
import { PaidServiceAvailabilityStatus } from "./useFetchPaidServiceAvailabilities";

export type PaidServiceConfig = {
  displayName: string;
  listDescription: string;
  enableDescription: string;
  disableDescription: string;
  features: string[];
  trialApplicationUrl?: string;
};

export const PAID_SERVICE_CONFIG: Record<PaidServiceName, PaidServiceConfig> = {
  learning_management: {
    displayName: "学習管理",
    listDescription:
      "生徒の学習記録時間を把握・分析できる機能や学習記録にコメント・いいねなどコミュニケーションができるようになります。",
    enableDescription:
      "学習管理を追加すると、生徒の学習状況を把握しやすくする以下の機能が利用できます。",
    disableDescription:
      "「学習管理」を停止すると、以下の機能は利用できなくなります。",
    features: [
      "生徒の学習記録時間の閲覧、分析（タイムライン、アナリティクス）機能",
      "学習記録へのいいね、コメント機能",
      "学習計画（プランニング）機能",
      "課題配信機能",
    ],
    trialApplicationUrl: "https://forms.gle/QNEcrRH8h42KBkzN9",
  },
  ai_question: {
    displayName: "AI質問",
    listDescription:
      "生徒のStudyplusアプリでAI質問が使えるようになります。生徒が質問した教材・単元や解決状況なども確認できます。",
    enableDescription:
      "生徒のStudyplusアプリ上でAI質問が使えるようになります。また、先生側でも以下の機能が利用できるようになります。",
    disableDescription:
      "「AI質問」を停止すると、以下の機能は利用できなくなります。",
    features: [
      "生徒がAI質問を行った教材・単元を把握",
      "AI質問をした結果、本人が解決・理解できたか",
    ],
    trialApplicationUrl: "https://forms.gle/QNEcrRH8h42KBkzN9",
  },
};

export const getPaidServiceConfig = (
  serviceName: PaidServiceName,
): PaidServiceConfig | undefined => {
  return PAID_SERVICE_CONFIG[serviceName];
};

// 有料サービスをonにできるのは、トライアル中(trial)または請求期間中(paid)の場合
export const ENABLEABLE_STATUSES: PaidServiceAvailabilityStatus[] = [
  "trial_off",
  "paid_off",
];

// トライアル中や請求期間中でなくても、有料サービスをoffにできる
export const DISABLEABLE_STATUSES: PaidServiceAvailabilityStatus[] = [
  "trial_on",
  "paid_on",
  "after_trial_on",
  "pre_trial_on",
  "before_trial_on",
];
